import { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useCart } from '../context/CartContext'
import { useTelegram } from '../context/TelegramContext'
import { createOrder, createPayment } from '../api'
import Header from '../components/Header'
import './Checkout.css'

const Checkout = () => {
  const navigate = useNavigate()
  const { cart, getCartTotal, clearCart, hapticFeedback } = useCart()
  const { showBackButton, hideBackButton, showAlert, user } = useTelegram()
  
  const [loading, setLoading] = useState(false)
  const [formData, setFormData] = useState({
    name: user?.first_name || '',
    phone: '',
    address: '',
    deliveryMethod: 'courier',
    paymentMethod: 'yukassa',
    notes: ''
  })

  useEffect(() => {
    if (cart.length === 0) {
      navigate('/cart')
      return
    }

    showBackButton(() => navigate('/cart'))
    return () => hideBackButton()
  }, [cart])

  const handleChange = (e) => {
    setFormData(prev => ({
      ...prev,
      [e.target.name]: e.target.value
    }))
  }

  const handleSubmit = async (e) => {
    e.preventDefault()

    if (!formData.name || !formData.phone || !formData.address) {
      showAlert('Пожалуйста, заполните все обязательные поля')
      return
    }

    try {
      setLoading(true)
      hapticFeedback('medium')

      const orderData = {
        user_id: user?.id || 0,
        items: cart.map(item => ({
          product_id: item.product_id,
          quantity: item.quantity,
          size: item.size,
          color: item.color,
          price: item.product.price
        })),
        customer_name: formData.name,
        customer_phone: formData.phone,
        delivery_method: formData.deliveryMethod,
        delivery_address: formData.address,
        payment_method: formData.paymentMethod,
        total_amount: getCartTotal(),
        notes: formData.notes
      }

      const order = await createOrder(orderData)

      if (formData.paymentMethod === 'yukassa') {
        const payment = await createPayment(order.id)
        if (payment.confirmation_url) {
          clearCart()
          window.location.href = payment.confirmation_url
        }
      } else {
        clearCart()
        showAlert('Заказ успешно оформлен! Мы свяжемся с вами в ближайшее время.')
        navigate('/')
      }

      hapticFeedback('success')
    } catch (error) {
      console.error('Ошибка оформления заказа:', error)
      const errorMessage = error.response?.data?.detail || error.message || 'Неизвестная ошибка'
      showAlert(`Ошибка: ${errorMessage}`)
      hapticFeedback('error')
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="checkout">
      <Header title="Оформление заказа" showBack={true} showCart={false} />

      <form onSubmit={handleSubmit} className="checkout-form">
        {/* Contact Info */}
        <div className="form-section">
          <h2>Контактные данные</h2>
          
          <div className="form-group">
            <label>Имя *</label>
            <input
              type="text"
              name="name"
              value={formData.name}
              onChange={handleChange}
              placeholder="Введите ваше имя"
              required
            />
          </div>

          <div className="form-group">
            <label>Телефон *</label>
            <input
              type="tel"
              name="phone"
              value={formData.phone}
              onChange={handleChange}
              placeholder="+7 (999) 123-45-67"
              required
            />
          </div>
        </div>

        {/* Delivery */}
        <div className="form-section">
          <h2>Доставка</h2>
          
          <div className="form-group">
            <label>Способ доставки</label>
            <select
              name="deliveryMethod"
              value={formData.deliveryMethod}
              onChange={handleChange}
            >
              <option value="courier">Доставка курьером</option>
              <option value="pickup">Самовывоз</option>
            </select>
          </div>

          <div className="form-group">
            <label>Адрес доставки *</label>
            <textarea
              name="address"
              value={formData.address}
              onChange={handleChange}
              placeholder="Улица, дом, квартира"
              rows="3"
              required
            />
          </div>
        </div>

        {/* Payment */}
        <div className="form-section">
          <h2>Оплата</h2>
          
          <div className="form-group">
            <label>Способ оплаты</label>
            <select
              name="paymentMethod"
              value={formData.paymentMethod}
              onChange={handleChange}
            >
              <option value="yukassa">Банковская карта</option>
              <option value="on_delivery">Наличными при получении</option>
            </select>
          </div>
        </div>

        {/* Notes */}
        <div className="form-section">
          <div className="form-group">
            <label>Комментарий к заказу</label>
            <textarea
              name="notes"
              value={formData.notes}
              onChange={handleChange}
              placeholder="Дополнительная информация"
              rows="2"
            />
          </div>
        </div>

        {/* Summary */}
        <div className="order-summary">
          <div className="summary-row">
            <span>Товары</span>
            <span>{getCartTotal()} ₽</span>
          </div>
          <div className="summary-row total">
            <span>Итого</span>
            <span className="total-price">{getCartTotal()} ₽</span>
          </div>
        </div>

        <button 
          type="submit" 
          className="btn btn-primary btn-submit"
          disabled={loading}
        >
          {loading ? 'Оформление...' : `Оформить заказ • ${getCartTotal()} ₽`}
        </button>
      </form>
    </div>
  )
}

export default Checkout


